// Chat Widget Toggle Functionality
class ChatWidget {
  constructor() {
    this.toggleButton = document.querySelector('.chat-toggle-button');
    this.iconsContainer = document.querySelector('.chat-icons-container');
    this.shopifyChat = document.querySelector('#shopify-chat');
    this.isOpen = false;
    
    this.init();
  }

  init() {
    if (!this.toggleButton || !this.iconsContainer) {
      console.warn('Chat widget elements not found');
      return;
    }

    this.toggleButton.addEventListener('click', () => this.toggle());
    
    // Close chat icons when clicking outside
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.chat-widget') && 
          !e.target.closest('#shopify-chat') && 
          this.isOpen) {
        this.close();
      }
    });

    // Prevent closing when clicking inside chat widget
    document.querySelector('.chat-widget')?.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    // Prevent closing when clicking inside shopify-chat
    if (this.shopifyChat) {
      this.shopifyChat.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }

  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.isOpen = true;
    this.toggleButton.classList.add('active');
    this.iconsContainer.classList.add('active');
    
    // Add fade-in class to body
    document.body.classList.add('fade-in');
    document.body.classList.remove('fade-out');
    
    // Show shopify-chat with fadeIn animation
    if (this.shopifyChat) {
      this.shopifyChat.classList.add('fade-in');
      this.shopifyChat.style.display = 'block';
    }
  }

  close() {
    this.isOpen = false;
    this.toggleButton.classList.remove('active');
    this.iconsContainer.classList.remove('active');
    
    // Add fade-out class to body
    document.body.classList.add('fade-out');
    document.body.classList.remove('fade-in');
    
    // Hide shopify-chat with fadeOut animation
    if (this.shopifyChat) {
      this.shopifyChat.classList.remove('fade-in');
      this.shopifyChat.classList.add('fade-out');
      
      // Hide element after animation completes
      setTimeout(() => {
        this.shopifyChat.style.display = 'none';
        this.shopifyChat.classList.remove('fade-out');
      }, 400);
    }
  }
}

// Initialize chat widget when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ChatWidget();
  });
} else {
  new ChatWidget();
}
